import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const getReceiptPdfUrl = (id) => `${API}/fee-receipt-print/${id}/pdf`;
export const getReceiptPdfUrlPortal = (id) => `${API}/fee-receipt-print-portal/${id}/pdf`;

/* FEE HEADS */
export const createFeeHead = (data) =>
  axiosInstance.post("/fee-heads/create", data).then((r) => r.data);
export const getAllFeeHeads = (filters = {}) =>
  axiosInstance.get("/fee-heads/all", { params: filters }).then((r) => r.data);
export const updateFeeHead = (id, data) =>
  axiosInstance.put(`/fee-heads/update/${id}`, data).then((r) => r.data);
export const deleteFeeHead = (id) =>
  axiosInstance.delete(`/fee-heads/delete/${id}`).then((r) => r.data);
export const createFeeHeadPortal = (data) =>
  axiosInstance.post("/fee-head-portal/create", data).then((r) => r.data);
export const getAllFeeHeadsPortal = (filters = {}) =>
  axiosInstance.get("/fee-head-portal/all", { params: filters }).then((r) => r.data);
export const updateFeeHeadPortal = (id, data) =>
  axiosInstance.put(`/fee-head-portal/update/${id}`, data).then((r) => r.data);
export const deleteFeeHeadPortal = (id) =>
  axiosInstance.delete(`/fee-head-portal/delete/${id}`).then((r) => r.data);

/* FEE STRUCTURES */
export const saveFeeStructure = (data) =>
  axiosInstance.post("/fee-structures/save", data).then((r) => r.data);
export const getFeeStructureByClass = (params) =>
  axiosInstance.get("/fee-structures/class", { params }).then((r) => r.data);
export const getFeeStructuresByYear = (params) =>
  axiosInstance.get("/fee-structures/year", { params }).then((r) => r.data);
export const saveFeeStructurePortal = (data) =>
  axiosInstance.post("/fee-structure-portal/save", data).then((r) => r.data);
export const getFeeStructureByClassPortal = (params) =>
  axiosInstance.get("/fee-structure-portal/class", { params }).then((r) => r.data);
export const getFeeStructuresByYearPortal = (params) =>
  axiosInstance.get("/fee-structure-portal/year", { params }).then((r) => r.data);

/* FEE MANAGEMENT */
export const generateFeeBatch = (data) =>
  axiosInstance.post("/fee-management/batch/generate", data).then((r) => r.data);
export const getBatches = (filters = {}) =>
  axiosInstance.get("/fee-management/batch/all", { params: filters }).then((r) => r.data);
export const updateBatchStatus = (id, data) =>
  axiosInstance.put(`/fee-management/batch/status/${id}`, data).then((r) => r.data);
export const assignCustomStudentFee = (data) =>
  axiosInstance.post("/fee-management/ledger/custom", data).then((r) => r.data);
export const getStudentFeeLedger = (studentId) =>
  axiosInstance.get(`/fee-management/ledger/student/${studentId}`).then((r) => r.data);
export const collectFeePayment = (data) =>
  axiosInstance.post("/fee-management/payment/collect", data).then((r) => r.data);
export const getReceipts = (filters = {}) =>
  axiosInstance.get("/fee-management/receipts/all", { params: filters }).then((r) => r.data);
export const getReceiptById = (id) =>
  axiosInstance.get(`/fee-management/receipts/${id}`).then((r) => r.data);
export const voidReceipt = (id, data) =>
  axiosInstance.put(`/fee-management/receipts/void/${id}`, data).then((r) => r.data);
export const getDefaulters = (filters = {}) =>
  axiosInstance.get("/fee-management/defaulters", { params: filters }).then((r) => r.data);
export const applyLateFee = (studentId) =>
  axiosInstance.post(`/fee-management/late-fee/apply/${studentId}`).then((r) => r.data);
export const removeLateFee = (studentId) =>
  axiosInstance.post(`/fee-management/late-fee/remove/${studentId}`).then((r) => r.data);

export const generateFeeBatchPortal = (data) =>
  axiosInstance.post("/fee-portal/batch/generate", data).then((r) => r.data);
export const getBatchesPortal = (filters = {}) =>
  axiosInstance.get("/fee-portal/batch/all", { params: filters }).then((r) => r.data);
export const updateBatchStatusPortal = (id, data) =>
  axiosInstance.put(`/fee-portal/batch/status/${id}`, data).then((r) => r.data);
export const assignCustomStudentFeePortal = (data) =>
  axiosInstance.post("/fee-portal/ledger/custom", data).then((r) => r.data);
export const getStudentFeeLedgerPortal = (studentId) =>
  axiosInstance.get(`/fee-portal/ledger/student/${studentId}`).then((r) => r.data);
export const collectFeePaymentPortal = (data) =>
  axiosInstance.post("/fee-portal/payment/collect", data).then((r) => r.data);
export const getReceiptsPortal = (filters = {}) =>
  axiosInstance.get("/fee-portal/receipts/all", { params: filters }).then((r) => r.data);
export const getReceiptByIdPortal = (id) =>
  axiosInstance.get(`/fee-portal/receipts/${id}`).then((r) => r.data);
export const voidReceiptPortal = (id, data) =>
  axiosInstance.put(`/fee-portal/receipts/void/${id}`, data).then((r) => r.data);
export const getDefaultersPortal = (filters = {}) =>
  axiosInstance.get("/fee-portal/defaulters", { params: filters }).then((r) => r.data);
export const applyLateFeePortal = (studentId) =>
  axiosInstance.post(`/fee-portal/late-fee/apply/${studentId}`).then((r) => r.data);
export const removeLateFeePortal = (studentId) =>
  axiosInstance.post(`/fee-portal/late-fee/remove/${studentId}`).then((r) => r.data);

export const getStudentFeeHistory = getStudentFeeLedger;
export const getStudentFeeHistoryPortal = getStudentFeeLedgerPortal;
export const getFeeReceipt = getReceiptById;
export const getFeeReceiptPortal = getReceiptByIdPortal;

export const getMyFeeLedger = () =>
  axiosInstance.get("/student-fee/my-ledger").then((r) => r.data);
export const getMyReceipts = () =>
  axiosInstance.get("/student-fee/my-receipts").then((r) => r.data);
export const studentPayFee = (data) =>
  axiosInstance.post("/student-fee/pay", data).then((r) => r.data);
export const getMyReceiptPrintData = (id) =>
  axiosInstance.get(`/student-fee/receipts/${id}/data`).then((r) => r.data);
export const getMyReceiptHtmlUrl = (id) => `${API}/student-fee/receipts/${id}/html`;

export const createLateFeeRule = (data) =>
  axiosInstance.post("/late-fee-rules/create", data).then((r) => r.data);
export const listLateFeeRules = (filters = {}) =>
  axiosInstance.get("/late-fee-rules/all", { params: filters }).then((r) => r.data);
export const updateLateFeeRule = (id, data) =>
  axiosInstance.put(`/late-fee-rules/update/${id}`, data).then((r) => r.data);
export const deleteLateFeeRule = (id) =>
  axiosInstance.delete(`/late-fee-rules/delete/${id}`).then((r) => r.data);
export const createLateFeeRulePortal = (data) =>
  axiosInstance.post("/late-fee-rule-portal/create", data).then((r) => r.data);
export const listLateFeeRulesPortal = (filters = {}) =>
  axiosInstance.get("/late-fee-rule-portal/all", { params: filters }).then((r) => r.data);
export const updateLateFeeRulePortal = (id, data) =>
  axiosInstance.put(`/late-fee-rule-portal/update/${id}`, data).then((r) => r.data);
export const deleteLateFeeRulePortal = (id) =>
  axiosInstance.delete(`/late-fee-rule-portal/delete/${id}`).then((r) => r.data);

export const createDiscountRule = (data) =>
  axiosInstance.post("/discount-rules/create", data).then((r) => r.data);
export const listDiscountRules = (filters = {}) =>
  axiosInstance.get("/discount-rules/all", { params: filters }).then((r) => r.data);
export const updateDiscountRule = (id, data) =>
  axiosInstance.put(`/discount-rules/update/${id}`, data).then((r) => r.data);
export const deleteDiscountRule = (id) =>
  axiosInstance.delete(`/discount-rules/delete/${id}`).then((r) => r.data);
export const createDiscountRulePortal = (data) =>
  axiosInstance.post("/discount-rule-portal/create", data).then((r) => r.data);
export const listDiscountRulesPortal = (filters = {}) =>
  axiosInstance.get("/discount-rule-portal/all", { params: filters }).then((r) => r.data);
export const updateDiscountRulePortal = (id, data) =>
  axiosInstance.put(`/discount-rule-portal/update/${id}`, data).then((r) => r.data);
export const deleteDiscountRulePortal = (id) =>
  axiosInstance.delete(`/discount-rule-portal/delete/${id}`).then((r) => r.data);

export const getFeeSettings = () =>
  axiosInstance.get("/fee-settings/").then((r) => r.data);
export const updateFeeSettings = (data) =>
  axiosInstance.put("/fee-settings/update", data).then((r) => r.data);
export const getFeeSettingsPortal = () =>
  axiosInstance.get("/fee-settings-portal/").then((r) => r.data);
export const updateFeeSettingsPortal = (data) =>
  axiosInstance.put("/fee-settings-portal/update", data).then((r) => r.data);

export const listPaymentModes = (filters = {}) =>
  axiosInstance.get("/payment-modes/all", { params: filters }).then((r) => r.data);
export const createPaymentMode = (data) =>
  axiosInstance.post("/payment-modes/create", data).then((r) => r.data);
export const updatePaymentMode = (id, data) =>
  axiosInstance.put(`/payment-modes/update/${id}`, data).then((r) => r.data);
export const deletePaymentMode = (id) =>
  axiosInstance.delete(`/payment-modes/delete/${id}`).then((r) => r.data);
export const listPaymentModesPortal = (filters = {}) =>
  axiosInstance.get("/payment-mode-portal/all", { params: filters }).then((r) => r.data);
export const createPaymentModePortal = (data) =>
  axiosInstance.post("/payment-mode-portal/create", data).then((r) => r.data);
export const updatePaymentModePortal = (id, data) =>
  axiosInstance.put(`/payment-mode-portal/update/${id}`, data).then((r) => r.data);
export const deletePaymentModePortal = (id) =>
  axiosInstance.delete(`/payment-mode-portal/delete/${id}`).then((r) => r.data);

export const listBankAccounts = (filters = {}) =>
  axiosInstance.get("/bank-accounts/all", { params: filters }).then((r) => r.data);
export const createBankAccount = (data) =>
  axiosInstance.post("/bank-accounts/create", data).then((r) => r.data);
export const updateBankAccount = (id, data) =>
  axiosInstance.put(`/bank-accounts/update/${id}`, data).then((r) => r.data);
export const deleteBankAccount = (id) =>
  axiosInstance.delete(`/bank-accounts/delete/${id}`).then((r) => r.data);
export const listBankAccountsPortal = (filters = {}) =>
  axiosInstance.get("/bank-account-portal/all", { params: filters }).then((r) => r.data);
export const createBankAccountPortal = (data) =>
  axiosInstance.post("/bank-account-portal/create", data).then((r) => r.data);
export const updateBankAccountPortal = (id, data) =>
  axiosInstance.put(`/bank-account-portal/update/${id}`, data).then((r) => r.data);
export const deleteBankAccountPortal = (id) =>
  axiosInstance.delete(`/bank-account-portal/delete/${id}`).then((r) => r.data);

export const listTaxConfigs = (filters = {}) =>
  axiosInstance.get("/tax-configs/all", { params: filters }).then((r) => r.data);
export const createTaxConfig = (data) =>
  axiosInstance.post("/tax-configs/create", data).then((r) => r.data);
export const updateTaxConfig = (id, data) =>
  axiosInstance.put(`/tax-configs/update/${id}`, data).then((r) => r.data);
export const deleteTaxConfig = (id) =>
  axiosInstance.delete(`/tax-configs/delete/${id}`).then((r) => r.data);
export const listTaxConfigsPortal = (filters = {}) =>
  axiosInstance.get("/tax-config-portal/all", { params: filters }).then((r) => r.data);
export const createTaxConfigPortal = (data) =>
  axiosInstance.post("/tax-config-portal/create", data).then((r) => r.data);
export const updateTaxConfigPortal = (id, data) =>
  axiosInstance.put(`/tax-config-portal/update/${id}`, data).then((r) => r.data);
export const deleteTaxConfigPortal = (id) =>
  axiosInstance.delete(`/tax-config-portal/delete/${id}`).then((r) => r.data);

export const listNotificationTemplates = (filters = {}) =>
  axiosInstance.get("/notification-templates/all", { params: filters }).then((r) => r.data);
export const createNotificationTemplate = (data) =>
  axiosInstance.post("/notification-templates/create", data).then((r) => r.data);
export const updateNotificationTemplate = (id, data) =>
  axiosInstance.put(`/notification-templates/update/${id}`, data).then((r) => r.data);
export const deleteNotificationTemplate = (id) =>
  axiosInstance.delete(`/notification-templates/delete/${id}`).then((r) => r.data);
export const listNotificationTemplatesPortal = (filters = {}) =>
  axiosInstance.get("/notification-template-portal/all", { params: filters }).then((r) => r.data);
export const createNotificationTemplatePortal = (data) =>
  axiosInstance.post("/notification-template-portal/create", data).then((r) => r.data);
export const updateNotificationTemplatePortal = (id, data) =>
  axiosInstance.put(`/notification-template-portal/update/${id}`, data).then((r) => r.data);
export const deleteNotificationTemplatePortal = (id) =>
  axiosInstance.delete(`/notification-template-portal/delete/${id}`).then((r) => r.data);

export const sendNotificationToStudent = (data) =>
  axiosInstance.post("/fee-notifications/student", data).then((r) => r.data);
export const sendBulkReminders = (data) =>
  axiosInstance.post("/fee-notifications/bulk-reminders", data).then((r) => r.data);
export const sendReceiptNotification = (data) =>
  axiosInstance.post("/fee-notifications/receipt", data).then((r) => r.data);
export const sendNotificationToStudentPortal = (data) =>
  axiosInstance.post("/fee-notification-portal/student", data).then((r) => r.data);
export const sendBulkRemindersPortal = (data) =>
  axiosInstance.post("/fee-notification-portal/bulk-reminders", data).then((r) => r.data);
export const sendReceiptNotificationPortal = (data) =>
  axiosInstance.post("/fee-notification-portal/receipt", data).then((r) => r.data);

export const createPaymentSchedule = (data) =>
  axiosInstance.post("/payment-schedules/create", data).then((r) => r.data);
export const listPaymentSchedules = (filters = {}) =>
  axiosInstance.get("/payment-schedules/all", { params: filters }).then((r) => r.data);
export const updatePaymentSchedule = (id, data) =>
  axiosInstance.put(`/payment-schedules/update/${id}`, data).then((r) => r.data);
export const deletePaymentSchedule = (id) =>
  axiosInstance.delete(`/payment-schedules/delete/${id}`).then((r) => r.data);
export const createPaymentSchedulePortal = (data) =>
  axiosInstance.post("/payment-schedule-portal/create", data).then((r) => r.data);
export const listPaymentSchedulesPortal = (filters = {}) =>
  axiosInstance.get("/payment-schedule-portal/all", { params: filters }).then((r) => r.data);
export const updatePaymentSchedulePortal = (id, data) =>
  axiosInstance.put(`/payment-schedule-portal/update/${id}`, data).then((r) => r.data);
export const deletePaymentSchedulePortal = (id) =>
  axiosInstance.delete(`/payment-schedule-portal/delete/${id}`).then((r) => r.data);

export const createRefund = (data) =>
  axiosInstance.post("/fee-refunds/create", data).then((r) => r.data);
export const listRefunds = (filters = {}) =>
  axiosInstance.get("/fee-refunds/all", { params: filters }).then((r) => r.data);
export const updateRefundStatus = (id, data) =>
  axiosInstance.put(`/fee-refunds/status/${id}`, data).then((r) => r.data);
export const createRefundPortal = (data) =>
  axiosInstance.post("/fee-refund-portal/create", data).then((r) => r.data);
export const listRefundsPortal = (filters = {}) =>
  axiosInstance.get("/fee-refund-portal/all", { params: filters }).then((r) => r.data);
export const updateRefundStatusPortal = (id, data) =>
  axiosInstance.put(`/fee-refund-portal/status/${id}`, data).then((r) => r.data);

export const getCollectionReport = (params = {}) =>
  axiosInstance.get("/fee-reports/collection", { params }).then((r) => r.data);
export const getDefaulterReport = (params = {}) =>
  axiosInstance.get("/fee-reports/defaulters", { params }).then((r) => r.data);
export const getComponentReport = (params = {}) =>
  axiosInstance.get("/fee-reports/component-wise", { params }).then((r) => r.data);
export const getDayBook = (params = {}) =>
  axiosInstance.get("/fee-reports/day-book", { params }).then((r) => r.data);
export const getIncomeSummary = (params = {}) =>
  axiosInstance.get("/fee-reports/income-summary", { params }).then((r) => r.data);
export const getCollectionReportPortal = (params = {}) =>
  axiosInstance.get("/fee-report-portal/collection", { params }).then((r) => r.data);
export const getDefaulterReportPortal = (params = {}) =>
  axiosInstance.get("/fee-report-portal/defaulters", { params }).then((r) => r.data);
export const getComponentReportPortal = (params = {}) =>
  axiosInstance.get("/fee-report-portal/component-wise", { params }).then((r) => r.data);
export const getDayBookPortal = (params = {}) =>
  axiosInstance.get("/fee-report-portal/day-book", { params }).then((r) => r.data);
export const getIncomeSummaryPortal = (params = {}) =>
  axiosInstance.get("/fee-report-portal/income-summary", { params }).then((r) => r.data);

const csvGet = (url, params = {}) =>
  axiosInstance.get(url, { params, responseType: "blob" }).then((r) => r.data);
export const exportCollectionCsv = (params = {}) => csvGet("/fee-exports/collection", params);
export const exportDefaultersCsv = (params = {}) => csvGet("/fee-exports/defaulters", params);
export const exportComponentWiseCsv = (params = {}) => csvGet("/fee-exports/component-wise", params);
export const exportStudentLedgerCsv = (params = {}) => csvGet("/fee-exports/student-ledger", params);
export const exportCollectionCsvPortal = (params = {}) => csvGet("/fee-export-portal/collection", params);
export const exportDefaultersCsvPortal = (params = {}) => csvGet("/fee-export-portal/defaulters", params);
export const exportComponentWiseCsvPortal = (params = {}) => csvGet("/fee-export-portal/component-wise", params);
export const exportStudentLedgerCsvPortal = (params = {}) => csvGet("/fee-export-portal/student-ledger", params);

export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const getReceiptPrintData = (id) =>
  axiosInstance.get(`/fee-receipt-print/${id}/data`).then((r) => r.data);
export const getReceiptHtmlUrl = (id) => `${API}/fee-receipt-print/${id}/html`;
export const getReceiptPrintDataPortal = (id) =>
  axiosInstance.get(`/fee-receipt-print-portal/${id}/data`).then((r) => r.data);
export const getReceiptHtmlUrlPortal = (id) => `${API}/fee-receipt-print-portal/${id}/html`;

// ── Receipt template settings — logo ────────────────────────────────────────
export const uploadReceiptLogo = (file) => {
  const formData = new FormData();
  formData.append("logo", file);
  return axiosInstance
    .post(`/fee-settings/receipt-template/logo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const uploadReceiptLogoPortal = (file) => {
  const formData = new FormData();
  formData.append("logo", file);
  return axiosInstance
    .post(`/fee-settings-portal/receipt-template/logo`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const deleteReceiptLogo = () =>
  axiosInstance.delete(`/fee-settings/receipt-template/logo`).then((r) => r.data);
export const deleteReceiptLogoPortal = () =>
  axiosInstance.delete(`/fee-settings-portal/receipt-template/logo`).then((r) => r.data);

// ── Receipt template settings — signature ───────────────────────────────────
export const uploadReceiptSignature = (file) => {
  const formData = new FormData();
  formData.append("signature", file);
  return axiosInstance
    .post(`/fee-settings/receipt-template/signature`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const uploadReceiptSignaturePortal = (file) => {
  const formData = new FormData();
  formData.append("signature", file);
  return axiosInstance
    .post(`/fee-settings-portal/receipt-template/signature`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data);
};
export const deleteReceiptSignature = () =>
  axiosInstance.delete(`/fee-settings/receipt-template/signature`).then((r) => r.data);
export const deleteReceiptSignaturePortal = () =>
  axiosInstance.delete(`/fee-settings-portal/receipt-template/signature`).then((r) => r.data);

/* WHATSAPP MESSAGE QUEUE LOGS — append to feeApi.js */
export const getQueueLogs = (params = {}) =>
  axiosInstance.get("/whatsapp-logs", { params }).then((r) => r.data);
export const getQueueLogsPortal = (params = {}) =>
  axiosInstance.get("/whatsapp-log-portal", { params }).then((r) => r.data);